document.addEventListener("DOMContentLoaded", function () {

    const btn = document.querySelector(".wishlist-btn");

    if (!btn) return;
    const handle = btn.dataset.productHandle;
    const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

    if (wishlist.includes(handle)) {
        btn.innerHTML = "❤️ Added to Wishlist";
    } else {
        btn.innerHTML = "🤍 Add to Wishlist";
    }
    btn.addEventListener("click", function (e) {

        e.preventDefault();

        const handle = this.dataset.productHandle;

        if (!handle) return;
        
        let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

        if (wishlist.includes(handle)) {
            wishlist = wishlist.filter(item => item !== handle);
            this.innerHTML = "🤍 Add to Wishlist";
        } else {
            wishlist.push(handle);
            wishlist = [...new Set(wishlist)];
            this.innerHTML = "❤️ Added to Wishlist";
        }

        localStorage.setItem("wishlist", JSON.stringify(wishlist));
        updateWishlistCount();

    });

    function updateWishlistCount() {
        const count = document.querySelector(".wishlist-count");
        if (count) {
            count.textContent = (JSON.parse(localStorage.getItem("wishlist")) || []).length;
        }
    }

    updateWishlistCount();

});
document.addEventListener("DOMContentLoaded", async function () {

    const container = document.getElementById("wishlist-products");

    if (!container) return;
    const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    container.innerHTML = "";
    const uniqueWishlist = [...new Set(wishlist)];

    if (wishlist.length === 0) {
        container.innerHTML = "<p>Your wishlist is empty.</p>";
        return;
    }

    for (const handle of wishlist) {

        try {

            const response = await fetch(`/products/${handle}.js`);

            if (!response.ok) continue;

            const product = await response.json();

            container.innerHTML += `
                <div class="wishlist-item">
                    <a href="${product.url}">
                        <img src="${product.featured_image}" alt="${product.title}">
                    </a>

                    <h3>${product.title}</h3>

                    <p>$${(product.price/100).toFixed(2)}</p>

                    <button
                        class="remove-wishlist"
                        data-handle="${handle}">
                        Remove
                    </button>
                </div>
            `;

        } catch (e) {
            console.error(e);
        }

    }

});
document.addEventListener("click", function (e) {

    const removeBtn = e.target.closest(".remove-wishlist");

    if (!removeBtn) return;

    e.preventDefault();

    const handle = removeBtn.dataset.handle;

    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

    wishlist = wishlist.filter(item => item !== handle);

    localStorage.setItem("wishlist", JSON.stringify(wishlist));

    // Xóa sản phẩm khỏi giao diện
    removeBtn.closest(".wishlist-item").remove();

    // Cập nhật số lượng trên header
    const count = document.querySelector(".wishlist-count");
    if (count) {
        count.textContent = wishlist.length;
    }

    // Nếu không còn sản phẩm
    const container = document.getElementById("wishlist-products");
    if (container && wishlist.length === 0) {
        container.innerHTML = "<p>Your wishlist is empty.</p>";
    }

});